var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 35,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 35,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1099 20.0517C19.1099 19.8196 19.2982 19.6322 19.5299 19.6322H27.0901C27.3219 19.6322 27.5099 19.8196 27.5099 20.0517C27.5099 20.2825 27.3219 20.4712 27.0901 20.4712H19.5299C19.2982 20.4712 19.1099 20.2825 19.1099 20.0517Z",
    fill: "#88919A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1099 21.7284C19.1099 21.4963 19.2982 21.3089 19.5299 21.3089H23.7299C23.9617 21.3089 24.15 21.4963 24.15 21.7284C24.15 21.9592 23.9617 22.1466 23.7299 22.1466H19.5299C19.2982 22.1466 19.1099 21.9592 19.1099 21.7284Z",
    fill: "#88919A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 11.7572C37.5 11.0648 36.9347 10.5 36.2401 10.5H17.7599C17.4352 10.5 17.1388 10.6235 16.9153 10.8258C16.6603 11.0553 16.5 11.3879 16.5 11.7572V24.2428C16.5 24.9352 17.0653 25.5 17.7599 25.5H36.2401C36.9347 25.5 37.5 24.9352 37.5 24.2428V11.7572ZM17.4061 11.5318C17.3644 11.597 17.3401 11.6744 17.3401 11.7572V13.8534H36.6599V11.7572C36.6599 11.5264 36.4708 11.3377 36.2401 11.3377H17.7599C17.6112 11.3377 17.4806 11.4151 17.4061 11.5318ZM17.3401 24.2537C17.3401 24.2496 17.3401 24.2469 17.3401 24.2428V16.7154H36.6599V24.2428C36.6599 24.4736 36.4708 24.6623 36.2401 24.6623H17.7599C17.6481 24.6623 17.5466 24.6189 17.4714 24.5469C17.4287 24.5062 17.3941 24.4573 17.3712 24.4017C17.3524 24.3555 17.3415 24.3053 17.3401 24.2537Z",
    fill: "#88919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCard);
export default __webpack_public_path__ + "static/media/NewCard.37d6fb81d067d797154f070583fd9d52.svg";
export { ForwardRef as ReactComponent };